module.exports = __webpack_public_path__ + "files/fe046b91bb7f21a1575de1559121c5df.png";